import React from 'react'
import { ToolsStyles } from './ToolsStyles'
import Text from '../../../../components/text/Text'

interface DataType {
    title: string
    subtitle: string
    link: string
}

export function ToolsComponent() {
    const handlerPress = (link: string) => {
        if (link) {
            window.open(link, '_blank')
        }
    }

    const data = [
        {
            image: require('../../../../assets/icons/guide-4.png'),
            link: 'https://www.amipass.com/crear-contenido-en-redes-sociales',
        },
        {
            image: require('../../../../assets/icons/guide-5.png'),
            link: 'https://www.youtube.com/watch?v=HVuvO74WwUo',
        },
    ]

    if (data.length === 0) return null

    return (
        <div style={ToolsStyles.container}>
            <Text
                label="Recursos para impulsar tu negocio"
                marginBottom={15}
                fontWeight={400}
                color="#184287"
                fontSize={27}
            />
            <div style={ToolsStyles.content}>
                {data.map((item, index) => (
                    <button
                        key={index}
                        style={ToolsStyles.btnContent}
                        onClick={() => handlerPress(item.link)}
                    >
                        <img
                            src={item.image}
                            width={220}
                            height={181}
                            style={{ borderRadius: 8 }}
                        />
                    </button>
                ))}
            </div>
        </div>
    )
}
